import { stringify } from "query-string"
import { apiInstance } from "./api"

const endpoint = "/address"

export const getAddresses = async queries => {
  const { dhFoods } = apiInstance()

  const query = stringify(queries, {
    skipEmptyString: true,
    skipNull: true
  })

  const response = await dhFoods.get(`${endpoint}?${query}`)

  return response.data
}

export const addAddress = async (data, queries) => {
  const { dhFoods } = apiInstance()

  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await dhFoods.post(`${endpoint}?${query}`, data)

  return response.data
}

export const deleteAddress = async (addressId, queries) => {
  const { dhFoods } = apiInstance()

  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await dhFoods.delete(`${endpoint}/${addressId}?${query}`)

  return response.data
}

export const editAddress = async (addressId, data, queries) => {
  const { dhFoods } = apiInstance()

  const query = stringify(queries, {
    skipEmptyString: true,
    skipNull: true
  })

  const response = await dhFoods.patch(`${endpoint}/${addressId}?${query}`, data)

  return response.data
}